import { render, staticRenderFns } from "./GToChatListButton.vue?vue&type=template&id=3018e87c&scoped=true&"
import script from "./GToChatListButton.vue?vue&type=script&lang=ts&"
export * from "./GToChatListButton.vue?vue&type=script&lang=ts&"
import style0 from "./GToChatListButton.vue?vue&type=style&index=0&id=3018e87c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3018e87c",
  null
  
)

export default component.exports